import { render, staticRenderFns } from "./TrainingSession.vue?vue&type=template&id=726f2b1b&scoped=true"
import script from "./TrainingSession.vue?vue&type=script&lang=js"
export * from "./TrainingSession.vue?vue&type=script&lang=js"
import style0 from "./TrainingSession.vue?vue&type=style&index=0&id=726f2b1b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f2b1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726f2b1b')) {
      api.createRecord('726f2b1b', component.options)
    } else {
      api.reload('726f2b1b', component.options)
    }
    module.hot.accept("./TrainingSession.vue?vue&type=template&id=726f2b1b&scoped=true", function () {
      api.rerender('726f2b1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/training/components/TrainingSession.vue"
export default component.exports